module.exports = __webpack_public_path__ + "static/media/206-gallery04.b46a5f43.jpg";